export default "__VITE_ASSET__BeY4wJY0__"